import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'changerequest-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css'],
})
export class StatusComponent implements OnInit {
  @Input('status') status: string;

  constructor() {}

  ngOnInit(): void {}
}
